<style lang="scss">
iframe{

}
</style>

<template>
  <div class="w-full video-wrapper justify-center lg:col-start-2 lg:col-span-10">
    <div class="plyr__video-embed" id="player" ref="player">
      <iframe :src="`https://player.vimeo.com/video/${videoId}?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media`"
              allowfullscreen
              allowtransparency></iframe>
    </div>
  </div>
</template>

<script>
//import Plyr from 'plyr';

export default {
  props: {
    videoId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      player: null,
    };
  },

  mounted() {
    var self = this;
    this.player = new Plyr(this.$refs.player, {
      controls: ['play-large'],
    });
  },

};
</script>
